import ApiClient from './ApiClient';
import { SubmitSelfAttestationResponseModel } from '../models/viewModels/Subscriptions/SubmitSelfAttestationResponseModel';

export default class SelfAttestationService extends ApiClient {

	async submitSelfAttestationResponse(model: SubmitSelfAttestationResponseModel) {
		return this.post('SelfAttestationResponse', model);
	}
}
